<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6">
      <!-- Card stats -->
      <b-row>
        <b-col>
          <b-button @click="getClientes" variant="info" size="sm"
            >Actualizar</b-button
          >
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card>
            <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
            <b-table striped hover condensed small :items="rows">
              <template #cell(icg_cliente_id)="data">
                <!-- <b-form-select size="sm" v-model="data.item.icg_cliente_id"></b-form-select> -->
                <!-- <b-badge v-if="data.item.icg_cliente_id" click="edit = data.item.ccodigocliente" variant="success">{{ data.item.icg_cliente_id }}</b-badge> -->
                <!-- <b-form-input size="sm" type="number"></b-form-input> -->
                <b-badge
                  @click="edit = data.item.CCODIGOCLIENTE"
                  v-if="
                    !data.item.icg_cliente_id &&
                    edit != data.item.CCODIGOCLIENTE
                  "
                  variant="danger"
                >
                  No Asociado
                </b-badge>
                <b-form-input
                  @keyup.enter="
                    updateAsociationCliente(
                      data.item.CCODIGOCLIENTE,
                      $event.target.value
                    )
                  "
                  v-if="edit == data.item.CCODIGOCLIENTE"
                  size="sm"
                  type="number"
                  :disabled="working"
                  autofocus
                  style="max-width: 100px"
                ></b-form-input>
                <b-badge
                  @click="edit = data.item.CCODIGOCLIENTE"
                  v-if="data.item.icg_cliente_id"
                  variant="success"
                  >{{ data.item.icg_cliente_id }}</b-badge
                >
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      working: false,
      error: null,
      rows: [],
      icg: [],
      edit: null,
    };
  },
  beforeMount() {
    this.getClientes();
  },
  methods: {
    getClientes() {
      this.$api.get("/pedidos/clientes").then((res) => {
        this.rows = res.data;
      });
    },
    getClientesIcg() {
      this.$api.get("/icg/clientes").then((res) => {
        this.icg = res.data;
      });
    },
    updateAsociationCliente(ccodigocliente, icg_cliente_id) {
      this.error = null;
      this.working = true;

      this.$api
        .put("/pedidos/clientes/asociacion", { ccodigocliente, icg_cliente_id })
        .then((res) => {
          this.rows.find((cliente, k) => {
            if (cliente.CCODIGOCLIENTE == ccodigocliente) {
              cliente.icg_cliente_id = icg_cliente_id;
              this.edit = null;
            }
          });
        })
        .catch((e) => {
          this.error = e;
        })
        .then(() => (this.working = false));
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
